"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeQueryString = void 0;
const removeQueryString = (url) => {
    const urlObject = new URL(url);
    urlObject.search = "";
    return urlObject.toString();
};
exports.removeQueryString = removeQueryString;
